import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { PreferencesWidgetWithStore } from 'components/PreferencesWidgetWithStore';
import { SearchFormDesktop } from 'components/SearchBox/Home/SearchFormDesktop';
import UserWidget from 'components/UserWidget';
import { getLanguageCode } from 'modules/meta/selectors';
import { getHomeUrlWithUTMParams } from 'utils/utmParams';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Header } from '@daedalus/atlas/Header';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { useBodyScrollLockObserver } from '@daedalus/atlas/Overlay/useBodyScrollLock';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { Page } from '@daedalus/core/src/analytics/types/Events';
import { getLocalizedContactUrl } from '@daedalus/core/src/brand/utils';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { BrandLogo } from '@daedalus/shared/src/whiteLabel/BrandLogo/BrandLogo';
const _exp = /*#__PURE__*/() => ({
  scrollBarGap
}) => scrollBarGap;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hy7fmpg",
  propsAsIs: false,
  vars: {
    "hy7fmpg-0": [_exp(), "px"]
  }
});
const SearchFormDesktopWrapper = /*#__PURE__*/styled('div')({
  name: "SearchFormDesktopWrapper",
  class: "swwc7ph",
  propsAsIs: false
});
export const BaseHomeDesktopHeader = ({
  withSearchForm = false,
  showSupportButton = true,
  hasShadow = false
}) => {
  const {
    brand,
    brandShowSignIn
  } = useBrand();
  const logoURL = getHomeUrlWithUTMParams();
  const {
    scrollBarGap
  } = useBodyScrollLockObserver();
  const {
    isDesktopXs,
    isDesktopSm
  } = useDeviceLayout();
  const languageCode = useSelector(getLanguageCode);
  const isTablet = isDesktopXs || isDesktopSm;
  const searchFormComponent = useMemo(() => withSearchForm && <SearchFormDesktopWrapper className={cx(isTablet && '__isTablet')}>
          <SearchFormDesktop />
        </SearchFormDesktopWrapper>, [withSearchForm, isTablet]);
  const handleNavigateSupportPage = () => window.open(getLocalizedContactUrl(brand, languageCode), '_blank');
  return <HeaderWrapper scrollBarGap={scrollBarGap}>
      <Header brand={brand} showLogo hasShadow={hasShadow} CenterComponent={!isTablet && searchFormComponent} RightComponent={<ContentWrapper paddingRight="s600">
            <Flex.Row gap="s300">
              {showSupportButton && <Button onClick={handleNavigateSupportPage} variant="quiet" size="md" iconStart={<Icon name="Help" />}>
                  <FormattedMessageWrapper id="support247" defaultMessage="Support 24/7" />
                </Button>}
              <PreferencesWidgetWithStore />
              {brandShowSignIn && <UserWidget page={Page.Home} />}
            </Flex.Row>
          </ContentWrapper>} logoUrl={logoURL} BottomComponent={isTablet && searchFormComponent} BrandLogoComponent={BrandLogo} />
    </HeaderWrapper>;
};

require("./BaseHomeDesktopHeader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BaseHomeDesktopHeader.tsx");